module.exports = __webpack_public_path__ + "static/img/left-home-row-3.0a8893fe.png";